import React, { useMemo, useEffect } from 'react';

import {
  EmmaPromoCard,
  EmmaSpace,
  EmmaText,
  EmmaCarousel,
  useBreakpoint,
  EmmaCampaignCard,
} from '@axa-asia/emma-stylesheet';
import './styles.scss';
import classNames from 'classnames';
import { t } from '../../../../locales';
import { useSelector } from 'react-redux';
import prismicApiClient from '../../../../../src/utils/prismicApi';
import { getCmsProfile } from '../../../../../src/selectors/userSelectors';
import {
  formatPromoCards,
  gaBannerClick,
} from '../../utils/prismicBannerUtils';

type Props = {
  lang: 'en' | 'zh';
};

const CWP_PROFILES = ['CWP'];

export const OffersContainer = ({ lang }: Props) => {
  const cmsProfiles = useSelector(getCmsProfile) || CWP_PROFILES;

  const useEventAndCampaignQuery = prismicApiClient.getOfferBanners({
    lang: lang,
    platform: 'WEB',
    tags: cmsProfiles,
    preloginOnly: 'POSTLOGIN_ONLY',
    myPrivilegesTab: 'EVENTS_AND_CAMPAIGNS',
    limit: 15,
  }).useHook;

  const eventAndCampaignQuery = useEventAndCampaignQuery();

  const eventAndCampaignCards = useMemo(() => {
    return formatPromoCards(
      eventAndCampaignQuery.data,
      lang,
      cmsProfiles,
      'events',
    );
  }, [cmsProfiles, eventAndCampaignQuery.data, lang]);

  useEffect(() => {
    if (!eventAndCampaignCards || !(eventAndCampaignCards?.length > 0)) {
      return;
    }
    eventAndCampaignCards.map((item) => {
      gaBannerClick(
        cmsProfiles,
        `events - ${item.title}`,
        'display',
        item.gaCampaignName,
        item.gaBannerCategory,
        item.gaCustomBannerCategory,
      );
    });
  }, [eventAndCampaignCards]);

  const useProductOffersQuery = prismicApiClient.getOfferBanners({
    lang: lang,
    platform: 'WEB',
    tags: cmsProfiles,
    preloginOnly: 'POSTLOGIN_ONLY',
    myPrivilegesTab: 'AXA_PRODUCT_OFFERS',
    limit: 15,
  }).useHook;

  // Debug section

  // useEffect(() => {
  //   console.log('XXX didmount');
  // }, []);

  // useEffect(() => {
  //   console.log('XXX useEventAndCampaignQuery changed', {
  //     useEventAndCampaignQuery,
  //   });
  // }, [useProductOffersQuery]);

  // useEffect(() => {
  //   console.log('XXX useProductOffersQuery changed', { useProductOffersQuery });
  // }, [useProductOffersQuery]);

  const productOffersQuery = useProductOffersQuery();

  const productOffersCards = useMemo(() => {
    return formatPromoCards(
      productOffersQuery.data,
      lang,
      cmsProfiles,
      'offers',
    );
  }, [cmsProfiles, productOffersQuery.data, lang]);

  useEffect(() => {
    if (!productOffersCards || !(productOffersCards?.length > 0)) {
      return;
    }
    productOffersCards.map((item) => {
      gaBannerClick(
        cmsProfiles,
        `offers - ${item.title}`,
        'display',
        item.gaCampaignName,
        item.gaBannerCategory,
        item.gaCustomBannerCategory,
      );
    });
  }, [productOffersCards]);

  const bp = useBreakpoint();

  return (
    <div className={classNames(EmmaSpace['pb64'])}>
      {eventAndCampaignCards?.length > 0 && (
        <>
          <div
            className={classNames(
              EmmaText['Title_L/LooseContent/Left/MineShaft'],
              EmmaSpace['mb16'],
              EmmaSpace['mt24'],
            )}
          >
            {t('UI_MY_PRIVILEGES_CAMPAIGNS_TITLE')}
          </div>
          <EmmaCarousel
            slidesPerViewLg={4}
            slidesPerView={1}
            shadowMargin
            disableMargin
          >
            {eventAndCampaignCards.map((value, index) => {
              return (
                <div key={index} className="emma-promo-banner-card-wrapper">
                  <EmmaPromoCard {...value} />
                </div>
              );
            })}
            {Array.from(
              {
                length:
                  bp === 'lg' && eventAndCampaignCards.length < 4
                    ? 4 - eventAndCampaignCards.length
                    : 0,
              },
              (_, index) => (
                <div key={`empty-${index}-${bp}`} />
              ),
            )}
          </EmmaCarousel>
        </>
      )}
      {productOffersCards?.length > 0 && (
        <>
          <div
            className={classNames(
              EmmaText['Title_L/LooseContent/Left/MineShaft'],
              EmmaSpace['mb16'],
              EmmaSpace['mt24'],
            )}
          >
            {t('UI_MY_PRIVILEGES_PRODUCT_TITLE')}
          </div>
          <EmmaCarousel
            slidesPerViewLg={4}
            slidesPerView={1}
            shadowMargin
            disableMargin
          >
            {productOffersCards.map((value, index) => {
              return (
                <div key={index} className="emma-promo-banner-card-wrapper">
                  <EmmaPromoCard {...value} />
                </div>
              );
            })}
            {Array.from(
              {
                length:
                  bp === 'lg' && productOffersCards.length < 4
                    ? 4 - productOffersCards.length
                    : 0,
              },
              (_, index) => (
                <div key={`empty-${index}-${bp}`} />
              ),
            )}
          </EmmaCarousel>
        </>
      )}
      <div
        className={classNames(
          EmmaText['Remarks-L/Loose/Left/MineShaft'],
          EmmaSpace['mt32'],
        )}
      >
        {t('UI_MY_PRIVILEGES_TERMS_APPLY')}
      </div>
    </div>
  );
};
